import React, { useEffect, useRef, useState } from 'react';
import PreviewArticle from './components/PreviewArticle';
import useQuery from '../../../util/useQuery';
import CookiePolicyService from '../../../services/CookiePolicy.service';
import GlobalService from '../../../services/Global.service';
import { sendHeightToIframe } from '../sendHeight';

export default function ViewCookie() {
    const params = useQuery();
    const id = params.get('id');
    const lang = params.get('lang');
    const [detail, setDetail] = useState(false);
    const [loading, setLoading] = useState(false);
    const [logo, setLogo] = useState('');
    const [cookieList, setCookieList] = useState();
    const ref = useRef();

    const getImage = async (companyLogoId) => {
        try {
            const { data } = await GlobalService.getImageNoSecure(
                companyLogoId
            );
            if (data.resultData?.imageId) {
                setLogo(`data:image/png;base64,${data.resultData?.imageId}`);
            } else {
                setLogo('');
            }
        } catch (error) {
            console.log(error);
        }
    };

    // get cookie list
    const getCookieList = async (domainId) => {
        const { data } = await CookiePolicyService.getCookieDomainPublic(
            domainId
        );
        const res = data?.resultData;
        return res;
    };

    useEffect(() => {
        const getCookiePolicyDetailPublic = async () => {
            try {
                const { data } =
                    await CookiePolicyService.getCookiePolicyDetailPublic(id);
                if (data?.resultData) {
                    const parse = JSON.parse(data?.resultData?.data);
                    setDetail(parse);
                    setLoading(false);
                    setLogo('');
                    if (parse?.cookiePolicy?.cookieCompanyLogoId) {
                        getImage(parse?.cookiePolicy?.cookieCompanyLogoId);
                    }
                    // get cookie list
                    const list = await getCookieList(
                        parse?.cookiePolicy?.domainId
                    );
                    setCookieList(list);
                    sendHeightToIframe(ref.current);
                } else {
                    setLoading(false);
                }
            } catch (error) {
                console.log(error);
                setLoading(false);
            }
        };
        if (id) getCookiePolicyDetailPublic();
        document.body.style.background = 'transparent';
    }, [id]);

    return (
        <div ref={ref}>
            <PreviewArticle
                logo={logo}
                lang={lang}
                detail={detail}
                loading={loading}
                mode="view"
                cookieList={cookieList}
            />
        </div>
    );
}
